import "./src/styles/global.css";
require("prismjs/themes/prism-okaidia.css");
